<template>
  <div class="v-avatar mutable" :class="avatarSizeClass" :style="avatarStyle">
    <img
      v-if="imgPath"
      v-lazy="imgPath"
      alt=""
      :height="avatarSize"
      :width="avatarSize"
    />
    <svg
      v-else
      class="v-avatar__placeholder"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle cx="12" cy="9.5" r="4" />
      <path d="M12 15c-4 0-7.5 2-7.5 5.5V24h15v-3.5C19.5 17 16 15 12 15z" />
    </svg>
  </div>
</template>

<script>
export function resolveAvatarImage(img, clean = false) {
  if (clean) return img;

  if (!img || img === true || img.endsWith('.com/')) {
    return '';
  }

  const pattern = /^((http|https):\/\/)/;
  const fullPath = `https://www.filepicker.io/api/file/${img}`;
  return !pattern.test(img) ? fullPath : img;
}

export default {
  name: 'Avatar',
  props: {
    img: {},
    size: {
      type: String,
      default: 'default',
      validator: (val) => {
        const allowedOptions = ['default', 'small', 'micro', 'large', 'xlarge'];
        return allowedOptions.includes(val);
      },
    },
    clean: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imgPath() {
      return this.getImgPath();
    },
    avatarSizeClass() {
      return this.size ? `v-avatar--${this.size}` : '';
    },
    avatarSize() {
      return this.getAvatarSize();
    },
    avatarStyle() {
      return {
        height: this.avatarSize + 'px',
        width: this.avatarSize + 'px',
      };
    },
  },
  methods: {
    getAvatarSize() {
      switch (this.size) {
        case 'micro': {
          return 24;
        }
        case 'small': {
          return 32;
        }
        case 'large': {
          return 60;
        }
        case 'xlarge': {
          return 100;
        }
        default: {
          return 40;
        }
      }
    },
    getImgPath() {
      return resolveAvatarImage(this.img, this.clean);
    },
  },
};
</script>

<style lang="less">
@avatar-micro: 24px;

.v-avatar {
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  // Derived from theme text/surface colors so the placeholder adapts to dark mode.
  background: color-mix(
    in srgb,
    var(--v-main-base) 16%,
    var(--v-itemBackground-base)
  );

  .v-avatar__placeholder {
    height: 100%;
    width: 100%;
    fill: color-mix(in srgb, var(--v-main-base) 40%, transparent);
  }

  img {
    border: 2px solid var(--v-main-base);
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }

  &:hover:after {
    background-color: var(--v-main-base);
    opacity: 0.16;
  }

  &:active:after {
    background-color: var(--v-dark-base);
    opacity: 0.32;
  }

  &--micro {
    min-width: @avatar-micro;

    img {
      border: none;
    }

    i.v-icon {
      font-size: calc(@avatar-micro + @avatar-micro / 20);
    }
  }
}
</style>
